
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19 3h-9v2h9V3z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.415 6.523c.319-.33.76-.523 1.228-.523h8.642C19.267 6 20 6.811 20 7.732v7.294c0 .446-.17.883-.49 1.212l-3.143 3.242c-.318.328-.758.52-1.225.52h-5.5a1.707 1.707 0 01-1.265-.565L6.643 17.4h-.846c-.522 0-.965-.25-1.258-.546C4.243 16.557 4 16.115 4 15.6V14H3v3H1V9h2v3h1v-1.6c0-.513.244-.953.536-1.249.29-.294.734-.551 1.26-.551h.847l1.733-2.034a.94.94 0 01.039-.043zm1.317 1.344L7.8 10.136a.944.944 0 01-.719.33H5.882v5.067H7.08c.277 0 .54.121.72.331l1.932 2.27h5.33l3.055-3.153V7.867H9.733z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M21 7h2v8h-2V7z","fill":"currentColor"}})])
          )
        }
      }
    